import * as React from 'react';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import AccessTime from '@mui/icons-material/AccessTime';
import { OrderScenario } from 'components/order/model/Order';

const PREFIX = 'NotWorkingHour';

const classes = {
    icon: `${PREFIX}icon`
};

const StyledBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    padding: theme.spacing(1.5),
    border: `1px solid ${theme.palette.primary.main}`,
    margin: theme.spacing(1.5),
    flexShrink: 0,
    [`& .${classes.icon}`]: {
        color: theme.palette.primary.main,
        marginRight: theme.spacing(1)
    }
}));

interface NotWorkingHourProps {
    scenario: OrderScenario;
}

export const NotWorkingHour: React.FC<React.PropsWithChildren<NotWorkingHourProps>> = ({ scenario }) => {
    const { t } = useTranslation();

    const description = React.useMemo(() => {
        switch (scenario) {
            case OrderScenario.PREORDER:
                return t('LOCATION_OUT_OF_HOURS_MESSAGE');
            case OrderScenario.ORDER_TO_TABLE:
                return t('LOCATION_OUT_OF_HOURS_OTT_MESSAGE');
            default:
                return t('LOCATION_OUT_OF_HOURS_OTT_MESSAGE');
        }
    }, [scenario, t]);

    return (
        <StyledBox>
            <AccessTime className={classes.icon} />
            <Typography>{description}</Typography>
        </StyledBox>
    );
};
